<div class="inner-content">
  <div class="popup-consent p-3">
    <!-- <div class="popup-close">
      <div class="modal-close" (click)="close()">
        <img src="assets/icon/close-blue.svg" alt="">
      </div>
    </div> -->

    <ion-card class="p-4 text-center">
      <div class="flex justify-end" (click)="close()">
        <ion-icon
          name="close-outline"
          class="cursor-pointer"
          color="dark"
          size="large"
        ></ion-icon>
      </div>
      <div class="mb-4" *ngIf="isRumahSaya">
        <div class="!mb-2 text-2xl font-bold">
          Anda akan dialihkan ke situs RumahsayaBCA
        </div>
        <div class="text-sm">
          Anda akan menuju ke situs luar BCA Expoversary 2025. Apakah Anda yakin
          ingin melanjutkan?
        </div>
      </div>

      <div class="mb-4" *ngIf="!isRumahSaya">
        <div class="!mb-2 text-2xl font-bold">
          Anda akan dialihkan ke link di luar situs ini
        </div>
        <div class="text-sm">
          Anda akan menuju ke situs luar BCA Expoversary 2025. Apakah Anda yakin
          ingin melanjutkan?
        </div>
      </div>

      <ion-button (click)="goTo()" mode="ios" expand="block" color="primary"
        >Melanjutkan dalam {{ countdown }}</ion-button
      >
      <ion-button
        (click)="close()"
        mode="ios"
        expand="block"
        class="btn-white !mt-[12px]"
        >Kembali</ion-button
      >

      <div *ngIf="false">
        <p class="m-0">
          Silakan baca
          <span class="cursor-pointer font-bold" (click)="goToTnc()"
            >Syarat &amp; Ketentuan</span
          >
        </p>
      </div>
    </ion-card>
  </div>
</div>
